var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/core-js/library/modules/_cof.js
 ** module id = 327
 ** module chunks = 0
 **/